export default __webpack_public_path__ + "43bf5cbd1ec25e5e4501d7f185b3cb73.png";